import styled from 'styled-components';
import Container from '../Container/Container';

export const FooterSection = styled.div`
  width: 100%;
  min-height: 100vh;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-color: rgba(39, 42, 46, 0.72);
  background-blend-mode: multiply;
  display: flex;
  flex-direction: column;

  h1 {
    color: #fff;
  }
`;

export const AboutSection = styled(Container)`
  @media (max-width: ${({ theme }) => theme.media.lg}) {
    height: min-content;
  }
`;
export const About = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AboutText = styled.div`
  font-size: 16px;
  line-height: 24px;
  p {
    text-indent: 32px;
    margin: 4px 0;
    &.no-indent {
      text-indent: 0;
    }
  }
`;

export const ContactWrapper = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

export const ContactItem = styled.li`
  font-size: 18px;
  font-weight: bold;
  margin: 12px 0;
  display: flex;
  align-items: center;
  img {
    margin-right: 8px;
    width: 28px;
  }
`;

export const ContactAddress = styled.address`
  font-size: 18px;
  font-style: normal;
  font-weight: bold;
  margin: 8px 0;
  display: flex;
  img {
    margin-right: 8px;
    width: 28px;
  }
`;
export const ContactMap = styled(Container)``;

export const FooterContainer = styled(Container)`
  footer {
    display: flex;
    flex-direction: column;
  }
  h2,
  p {
    margin: 0;
    text-align: center;
  }
  .social-icons {
    margin-top: 16px;
    display: flex;
    justify-content: center;
    gap: 12px;
  }
`;
